'use strict';

const React = require('react'),
  {merge} = require('lodash/object'),
  get = require('lodash/object').get,
  {t} = require('services/i18nextWrapper'),
  moment = require('moment'),
  Notification = require('components/Notification/Notification'),
  {PropTypes} = require('react'),
  {find} = require('lodash/collection'),
  {cloneDeep} = require('lodash/lang'),
  {delay} = require('lodash/function'),
  ContentUtils = require('utils/ContentUtils'),
  OrderUtils = require('utils/OrderUtils'),
  ActionTypes = require('constants/AppConstants').ActionTypes,
  {
    formatTasksProducts,
    addProductOrderIdToTasks,
    removeDefaultTaskWhenExistCustom,
    changeLabelName,
    changeLabelNote,
    getTasksFromProcess,
    updateTask
  } = require('components/DashboardModal/DashboardModalUtils'),
  AppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
  actions = require('constants/AppConstants').Analytics.actions,
  ga = require('react-ga'),
  {
    onChangeBrewDate,
    onChangeFiltrationDate,
    onChangePackagingDate,
    onChangeBeerStyle,
    onChangeBriteTank,
    onChangeFermenterTank,
    getNewModalState,
    onChangeTaskType,
    onChangeTask,
    onDeleteTask,
    onChangeBrewTurnNew,
    isValidForm,
    cleanModal,
    onChangeVolumeNew,
    onChangeProcess,
    initializePackagingTask,
    initializeFermentingTask,
    initializeBrewingTurns,
    formatBatchs,
    someProductAlreadyConfirmed,
    updateStateTask
  } = require('stores/DashboardModalStore/DashboardModalBrewStore/DashboardModalBrewStore'),
  InventoryStore = require('stores/InventoryStore'),
  DashboardServiceCache = require('services/DashboardServiceCache'),
  DateUtils = require('utils/DateUtils'),
  OrderStore = require('stores/OrderStore'),
  SessionStore = require('stores/SessionStore'),
  DashboardModalBrewBody = require('../DashboardModalBrewBody/DashboardModalBrewBody'),
  INDEX_FIRST_TAB = 0,
  categories = require('constants/AppConstants').Analytics.categories,
  {TIME_WAIT_MODAL_EXPAND} = require('constants/AppConstants'),
  {Tab, Tabs} = require('material-ui');

const ModalDashboardBrewNew = React.createClass({displayName: "ModalDashboardBrewNew",
  propTypes: {
    isSingleMode: PropTypes.boolean,
    isBHAllowed: PropTypes.boolean,
    isFVAllowed: PropTypes.boolean,
    isBTAllowed: PropTypes.boolean,
    tankSelected: PropTypes.obj,
    onActiveFirstTab: PropTypes.function
  },
  
  /**
   * A temporary id which use to recognize the order before
   * was created in order store.
   */
  temporaryOrderId: null,
  
  /**
   * Orders cloned to work safely with the temporary order.
   */
  ordersCloned: null,
  
  /**
   * This obj need it in order to the childs register their refs components,
   * And can use them from here to make validation stuffs (the parent).
   */
  _refs: {
    brewDate: null,
    beerStyle: null,
    briteTank: null,
    commentOrder: null,
    filtrationDate: null,
    fermenterTank: null,
    orderDate: null
  },
  
  triggerValidation(nextState) {
    return this.isValidForm(nextState).messagesError;
  },
  
  componentWillMount() {
    const {isBHAllowed, isFVAllowed, isBTAllowed} = this.props;
    let nextState = getNewModalState(
      this.props.order,
      isBHAllowed,
      isFVAllowed,
      isBTAllowed
    );
    
    this.temporaryOrderId = get(nextState, 'order.id');
    
    this.setState(nextState);
  },
  
  componentWillReceiveProps(nextProps, nextState) {
    const {isBHAllowed, isFVAllowed, isBTAllowed} = nextProps;
    let computedNextState = getNewModalState(
      nextProps.order,
      isBHAllowed,
      isFVAllowed,
      isBTAllowed
    );
    
    if (
      nextProps.shouldNotUpdate &&
      !nextState.changeCamefromCurrentComponent
    ) {
      computedNextState.triggerNotUpdate = true;
    } else {
      computedNextState.triggerNotUpdate = false;
    }
    
    this.setState(computedNextState);
  },
  
  shouldComponentUpdate(nextProps, nextState) {
    // always render unless we should declare manually should NOT be render.
    const shouldRender = nextState.triggerNotUpdate ? false : true;
    return shouldRender;
  },
  
  componentDidUpdate() {
    this.state.changeCamefromCurrentComponent = false;
  },
  
  getInitialState() {
    return {
      isVolumeAlreadySuggested: false,
      isBeerStyleAlreadyDefined: false,
      triggerNotUpdate: false,
      changeCamefromCurrentComponent: false,
      isSomeProductAlreadyConfirmed: false,
      isBrewingProductsLoaded: false,
      isFermentingProductsLoaded: false,
      isPackagingProductsLoaded: false
    };
  },
  
  componentDidMount() {
    // set temporary to find after update estimation inventory in each task
    this.temporaryOrderId = ContentUtils.getRandomId();
    // save the order safely to non change at dashboard level anything
    this.ordersCloned = cloneDeep(DashboardServiceCache.getOrdersSorted());
  },
  
  componentWillUnmount() {
    this.temporaryOrderId = null;
    this.ordersCloned = null;
  },
  
  /**
   * This method will execute all validation needed for this form.
   *
   * @param nextState
   * @public
   * @returns {*}
   */
  isValidForm(nextState) {
    return isValidForm(nextState || this.state, this._refs);
  },
  
  /**
   * This method will add new brew order.
   * @param afterSubmit
   */
  submit(parentRefs, afterSubmit) {
    const isValidResult = this.isValidForm();
    if (isValidResult && !isValidResult.isValid) {
      this.setState(isValidResult.messagesError, () => {
        if (this.refs.refTabs) {
          this.refs.refTabs.setState({
            selectedIndex: 0
          });
        }
      });
      return;
    }
    
    let order = {};
    order.applicant = SessionStore.getCurrentApplicant();
    order.dateCreated = moment().format(); // it's needed to calculate properly batch number
    order.styleBeerId = this.state.styleBeerSelected.id;
    order.briteTankId = this.state.briteTankSelected.tankObj.id;
    order.fermenterTankId = this.state.fermenterTankSelected.tankObj.id;
    order.styleBeer = this.state.styleBeerSelected;
    order.batchNumber = parentRefs.batchNumber.getValue();
    order.briteTank = this.state.briteTankSelected.tankObj;
    order.fermenterTank = this.state.fermenterTankSelected.tankObj;
    order.orderDate = DateUtils.toDateText(this.state.orderDate);
    order.brewDate = DateUtils.toDateText(this.state.brewDate);
    order.filtrationDate = DateUtils.toDateText(this.state.filtrationDate);
    order.comment = this.state.commentOrder;
    order.volume = ContentUtils.getNumber(this.state.orderVolume);
    order.fermenterTasks = ContentUtils.cleanAllTasksOfProducts(
      addProductOrderIdToTasks(
        formatTasksProducts(
          removeDefaultTaskWhenExistCustom(this.state.fermenterTasks))));
    order.packagingTasks = ContentUtils.cleanAllTasksOfProducts(
      addProductOrderIdToTasks(
        formatTasksProducts(
          removeDefaultTaskWhenExistCustom(this.state.packagingTasks))));
    
    const batchs = ContentUtils.cleanAllTasksOfProducts(get(this.state, 'order.batchs'));
    
    let isBHAllowed;
    
    if (get(batchs, 'length', 0) > 0) {
      order.batchs = addProductOrderIdToTasks(
        formatTasksProducts(
          formatBatchs(batchs)));
      isBHAllowed = true;
    } else {
      order.batchs = [];
      isBHAllowed = false;
    }
    
    const onSuccess = () => {
      // on success
      ga.event({
        category: categories.ORDER,
        action: actions.NEW,
        label: 'Applicant: ' +
          SessionStore.getCurrentApplicant() +
          ' User: ' +
          ContentUtils.getSession('userNameSession')
      });
      this.clean();
      afterSubmit();
    };
    
    const onFailure = errorMessage =>
      this.setState({volumenTankMessageError: errorMessage});
    
    OrderStore.addOrder(order, onSuccess, onFailure, isBHAllowed);
  },
  
  clean() {
    cleanModal(this);
  },
  
  _onChangeBrewDate(_, brewDate) {
    if (!SessionStore.isAbleToEditDates()) {
      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
      return;
    }
    if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.brewDate, brewDate)) {
       Notification.show(t('notification_unconfirm_product_and_try_again'));
      return;
    }
    
    this.setState(prevState => {
      let nextState = onChangeBrewDate(prevState, brewDate, this.props.isBHAllowed);
      nextState = merge(nextState, this.triggerValidation(nextState));
      nextState.changeCamefromCurrentComponent = true;
      return nextState;
    });
  },
  
  _onChangeOrderDate(nill, orderDate) {
    if (!SessionStore.isAbleToEditDates()) {
      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
      return;
    }
    if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.orderDate, orderDate)) {
       Notification.show(t('notification_unconfirm_product_and_try_again'));
      return;
    }
    
    this.setState(prevState => {
      let nextState = onChangePackagingDate(prevState, orderDate, this.props.isBHAllowed);
      nextState = merge(nextState, this.triggerValidation(nextState));
      nextState.changeCamefromCurrentComponent = true;
      return nextState;
    });
  },
  
  _onChangeFiltrationDate(nill, filtrationDate) {
    if (!SessionStore.isAbleToEditDates()) {
      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
      return;
    }
    if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.filtrationDate, filtrationDate)) {
       Notification.show(t('notification_unconfirm_product_and_try_again'));
      return;
    }
    
    this.setState(prevState => {
      let nextState = onChangeFiltrationDate(prevState, filtrationDate, this.props.isBHAllowed);
      nextState = merge(nextState, this.triggerValidation(nextState));
      nextState.changeCamefromCurrentComponent = true;
      return nextState;
    });
  },
  
  _onChangeBeerStyle(evt) {
    const self = this;
    const beerStyleSelected = merge(evt, evt.itemModel);
    this.setState(prevState => {
       // clean batch if style change to clear products
      prevState.order.batchs && (prevState.order.batchs = [])
        let nextState = onChangeBeerStyle(
        prevState,
        beerStyleSelected,
        get(
          self.props,
          'tankSelected.type',
          get(self.props, 'tankTypeClicked')
        ),
        self.props.isBHAllowed
      );
      nextState = merge(nextState, self.triggerValidation(nextState));
      nextState.changeCamefromCurrentComponent = true;
      
      // set the id of the draft order to be consistent
      let oldOrder = find(self.ordersCloned, orderFind => orderFind.id === self.temporaryOrderId);
      nextState.order.id = self.temporaryOrderId;
      if (oldOrder) {
        oldOrder.id = self.temporaryOrderId;
      }


      
      // auto populate each product given the volume of the order
      this.ordersCloned = ContentUtils.replaceByAttributes(self.ordersCloned, nextState.order, 'id');
      
      nextState.isBeerStyleAlreadyDefined = true;
      return nextState;
    }, () => {
      AppDispatcher.dispatch({
        type: ActionTypes.DASHBOARD_MODAL_CHANGE_BEER_STYLE,
        volume: this.state.orderVolume,
        batchNumber: this.state.batchNumber,
        order: null,
        isSingle: false
      });
    });
  },
  
  _onChangeBriteTank(evt, index, menuItem) {
    if (!SessionStore.isAbleToEditDates()) {
      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
      return;
    }
    this.setState(prevState => {
      let nextState = onChangeBriteTank(prevState, menuItem, this.props.isBHAllowed);
      nextState = merge(nextState, this.triggerValidation(nextState));
      nextState.changeCamefromCurrentComponent = true;
      return nextState;
    });
  },
  
  _onChangeFermenterTank(evt, index, menuItem) {
    if (!SessionStore.isAbleToEditDates()) {
      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
      return;
    }
    this.setState(prevState => {
      let nextState = onChangeFermenterTank(prevState, menuItem, this.props.isBHAllowed);
      nextState = merge(nextState, this.triggerValidation(nextState));
      nextState.changeCamefromCurrentComponent = true;
      return nextState;
    });
  },
  
  _onDeleteTask(itemSelected, typeTask, dateTask) {
    this.setState(
      prevState => {
        const nextState = onDeleteTask(
          prevState.packagingTasks,
          prevState.fermenterTasks,
          typeTask,
          dateTask
        );
        nextState.changeCamefromCurrentComponent = true;
        return nextState;
      }
    );
  },
  
  _onChangeVolume(evt) {
    const volume = get(evt, 'target.value');
    this.setState(prevState => {
      let nextState = onChangeVolumeNew(prevState, volume, this.props.isBHAllowed);
      nextState = merge(nextState, this.triggerValidation(nextState));
      nextState.changeCamefromCurrentComponent = true;
      return nextState;
    }, () => {
      AppDispatcher.dispatch({
        type: ActionTypes.DASHBOARD_MODAL_CHANGE_VOLUME,
        volume: this.state.orderVolume,
        batchNumber: this.state.batchNumber,
        order: null,
        isSingle: false
      });
    });
  },
  
  _onChangeComment(evt) {
    const commentOrder = get(evt, 'target.value');
    this.setState({
      commentOrder
    });
  },
  
  _onChangeTask(itemSelected, typeTask, dateTask, field, evt) {
    
    if (!SessionStore.isAbleToEditAllWithoutDates()) {
      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
      return;
    }
    const targetValue = get(evt, 'target.value', '');
    this.setState(prevState => {
      let nextState = onChangeTask(
        targetValue,
        prevState.packagingTasks,
        prevState.fermenterTasks,
        typeTask,
        dateTask,
        field
      );
      return nextState;
    });
  },
  
  _onChangeAmountItem(productChanged, itemChanged, newAmount) {
    itemChanged.amount = newAmount;
    itemChanged.manualAmount = newAmount;
    itemChanged.item.amount = newAmount;
    
    // update the list of items from product
    const items = get(productChanged, 'items');
    const itemsChanged = ContentUtils.replace(items, itemChanged, 'id');
    productChanged.items = itemsChanged;
    productChanged = InventoryStore.onChangeProductByAmount(productChanged, newAmount);
    return productChanged;
  },
  
  _onChangeProducts(productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct) {
    let taskWithProductUpdated;
    this.setState(prevState => {
      const endDateOrder = OrderUtils.getEndDateOrder(prevState.order);
      const nextState = InventoryStore.onChangeProducts(
        this.ordersCloned,
        prevState,
        productWithoutChange,
        newAmount,
        uniqueId,
        task,
        avoidMultiplyItemByAmountProduct,
        endDateOrder
      );
      
      taskWithProductUpdated = nextState.taskWithProductUpdated;
      this.ordersCloned = nextState.ordersCloned;
      nextState.taskWithProductUpdated = null;
      return nextState;
    }, () => {
      AppDispatcher.dispatch({
        type: ActionTypes.DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT,
        newAmount,
        order: this.state.order,
        batchNumber: this.state.batchNumber,
        isSingle: false,
        taskUpdated: task,
        taskWithProductUpdated
      });
    });
  },
  
  _onChangeVolumeItem(product, newPorcent, uniqueId, task) {
    this._onChangeProducts(product, product.amount, uniqueId, task);
  },
  
  _onChangeProductsNonUpdated(productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct) {
    const endDateOrder = OrderUtils.getEndDateOrder(get(this.state, 'order'));
    return InventoryStore.onChangeProducts(this.ordersCloned, this.state, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder);
  },
  
  _onChangeTaskType(oldItemSelected,
                    typeTask,
                    dateTask,
                    itemSelected,
                    evt) {
    this.setState(
      prevState => {
        let nextState;
        
        if (typeTask === 'BH') {
          nextState = onChangeBrewTurnNew(
            oldItemSelected,
            dateTask,
            'batchs',
            prevState,
            itemSelected.turnId,
            evt.target.value,
            itemSelected
          );
        } else {
          nextState = onChangeTaskType(
            oldItemSelected,
            typeTask,
            dateTask,
            prevState,
            evt,
            itemSelected
          );
        }
        
        nextState.changeCamefromCurrentComponent = true;
        return nextState;
      });
  },
  
  _onChangeBrewingTaskType(oldItemSelected,
                           turnDate,
                           fieldName,
                           turnId,
                           newItemSelected) {
    
    const targetValue = get(newItemSelected, 'payload');
    this.setState(prevState => {
      let nextState = onChangeBrewTurnNew(
        oldItemSelected,
        turnDate,
        fieldName,
        prevState,
        turnId,
        targetValue,
        newItemSelected
      );
      nextState.changeCamefromCurrentComponent = true;
      return nextState;
    });
  },
  
  _onChangeNote(oldItemSelected, typeTask, dateTask, evt) {
    const targetValue = get(evt, 'target.value');
    const itemSelectedUpdated = changeLabelNote(oldItemSelected, targetValue);
    this.setState(updateStateTask(this.state, itemSelectedUpdated));
  },
  
  _onChangeName(oldItemSelected, typeTask, dateTask, evt) {
    const targetValue = get(evt, 'target.value');
    const itemSelectedUpdated = changeLabelName(oldItemSelected, targetValue);
    this.setState(updateStateTask(this.state, itemSelectedUpdated));
  },
  
  _onChangeProcess(newProcessOrder) {
    const tasks = getTasksFromProcess(newProcessOrder, this.state);
    const result = onChangeProcess(this.state, newProcessOrder.existingProcess, newProcessOrder, tasks);
    result.changeCamefromCurrentComponent = true;
    this.setState(result);
  },
  
  _notifyToParentIfVolumeAlreadyChanged(prevState, nextState, props) {
    if (prevState.orderVolume !== nextState.orderVolume) {
      props.onChangeVolume(prevState, nextState);
    }
  },
  
  _onChangeAmountInLocation(task, productUpdated) {
    const avoidMultiplicateAmountItems = true;
    this._onChangeProducts(productUpdated, productUpdated.amount, '', task, avoidMultiplicateAmountItems);
  },
  
  _onChangeCloseOrder() {
    this.setState(prevState => {
      let order = get(prevState, 'order');
      order.closed = !order.closed;
      return {
        order
      };
    });
  },
  
  _onConfirmProduct(product, uniqueId, task) {
    this.setState(prevState => {
      let result = InventoryStore.onConfirmProduct(prevState, product, task, this.ordersCloned, this.temporaryOrderId);
      this.ordersCloned = result.ordersCloned;
      result.ordersCloned = null;
      result = someProductAlreadyConfirmed(prevState);
      return result;
    }, () => {
      this._onChangeProducts(product, product.amount, uniqueId, task);
    });
  },
  
  _onToggleExpand(existingTask) {
    delay(() => {
      const hydratedTask = InventoryStore.hydrateTaskWithProducts(existingTask, get(this.state, 'styleBeerSelected.id'));
      this._updateExistingTask(hydratedTask);
    }, TIME_WAIT_MODAL_EXPAND);
  },
  
  _updateExistingTask(updatedTask) {
    if (SessionStore.isFullPaidVersion()) {
      if (updatedTask.sectionType === 'BREWHOUSE_TASK') {
        this.setState(prevState => {
          prevState.order.batchs = updateTask(prevState.batchs, updatedTask);
          prevState.batchs = prevState.order.batchs;
          return prevState;
        });
      } else if (updatedTask.sectionType === 'FERMENTER_TASK') {
        this.setState(prevState => {
          prevState.order.fermenterTasks = updateTask(prevState.order.fermenterTasks, updatedTask);
          prevState.fermenterTasks = prevState.order.fermenterTasks;
          return prevState;
        });
      } else {
        this.setState(prevState => {
          prevState.order.packagingTasks = updateTask(prevState.order.packagingTasks, updatedTask);
          prevState.packagingTasks = prevState.order.packagingTasks;
          return prevState;
        });
      }
    }
  },
  
  render() {
    let brewingTab, brewingTasks;
    const fermentingTask = initializeFermentingTask(this);
    const packagingTask = initializePackagingTask(this);
    const batchs = get(this.state, 'order.batchs');
    
    const bodyContent = (
      React.createElement(DashboardModalBrewBody, {
        isBeerStyleAlreadyDefined: this.state.isBeerStyleAlreadyDefined, 
        parentState: this.state, 
        onChangeCloseOrder: this._onChangeCloseOrder, 
        onChangeBrewDate: this._onChangeBrewDate, 
        onChangeFiltrationDate: this._onChangeFiltrationDate, 
        onChangeOrderDate: this._onChangeOrderDate, 
        onChangeBeerStyle: this._onChangeBeerStyle, 
        onChangeBriteTank: this._onChangeBriteTank, 
        onChangeVolume: this._onChangeVolume, 
        onChangeComment: this._onChangeComment, 
        onChangeFermenterTank: this._onChangeFermenterTank, 
        refsSubscriber: this._refs}
      )
    );
    
    if (!batchs) {
      // enter here means that the order don't with brewhouse
      return (
        React.createElement(Tabs, {
          ref: "refTabs", 
          className: "modal-order-dialog", 
          initialSelectedIndex: INDEX_FIRST_TAB
        }, 
          React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general')}, 
            React.createElement("div", {className: "modal-order-container fluid-container"}, 
              bodyContent
            )
          ), 
          React.createElement(Tab, {
            onActive: this.props.onActiveFirstTab, 
            label: t('dashboard_modal_tab_fermenting')
          }, 
            React.createElement("div", {className: "modal-order-task-container"}, 
              React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                fermentingTask
              )
            )
          ), 
          
          React.createElement(Tab, {
            onActive: this.props.onActiveFirstTab, 
            label: t('dashboard_modal_tab_packaging')
          }, 
            React.createElement("div", {className: "modal-order-task-container"}, 
              React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                packagingTask
              )
            )
          )
        )
      );
    } else if (get(batchs, 'length') === 0) {
      // enter here means that the order work with brewhouse but don't have batch
      brewingTab = (
        React.createElement(Tab, {
          onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing')}, 
          React.createElement("div", {className: "modal-order-task-container"}, 
            React.createElement("br", null), 
            React.createElement("div", {className: "modal-order-task-list container-fluid text-center"}, 
              React.createElement("h5", null, t('dashboard_modal_order_volume_zero'))
            )
          )
        )
      );
      
      return (
        React.createElement(Tabs, {
          ref: "refTabs", 
          className: "modal-order-dialog", 
          initialSelectedIndex: INDEX_FIRST_TAB
        }, 
          React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general')}, 
            React.createElement("div", {className: "modal-order-container fluid-container"}, 
              bodyContent
            )
          ), 
          brewingTab, 
          
          React.createElement(Tab, {
            onActive: this.props.onActiveFirstTab, 
            label: t('dashboard_modal_tab_fermenting')
          }, 
            React.createElement("div", {className: "modal-order-task-container"}, 
              React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                fermentingTask
              )
            )
          ), 
          React.createElement(Tab, {
            onActive: this.props.onActiveFirstTab, 
            label: t('dashboard_modal_tab_packaging')
          }, 
            React.createElement("div", {className: "modal-order-task-container"}, 
              React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                packagingTask
              )
            )
          )
        )
      );
    } else if (get(batchs, 'length') > 0) {
      // enter here means that the order have batchs availables in brewhouse
      brewingTasks = initializeBrewingTurns(
        batchs,
        this._onChangeBrewingTaskType,
        this._onChangeProcess,
        this._onChangeProducts,
        this._onChangeAmountItem,
        this._onChangeVolumeItem,
        this._onChangeAmountInLocation,
        null, // non selected task before
        this._onConfirmProduct,
        this
      );
      
      const brewingTab = (
        React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing')}, 
          React.createElement("div", {className: "modal-order-task-container"}, 
            React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
              brewingTasks
            )
          )
        )
      );
      
      return (
        React.createElement(Tabs, {
          ref: "refTabs", 
          className: "modal-order-dialog", 
          initialSelectedIndex: INDEX_FIRST_TAB
        }, 
          React.createElement(Tab, {onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general')}, 
            React.createElement("div", {className: "modal-order-container fluid-container"}, 
              bodyContent
            )
          ), 
          
          brewingTab, 
          
          React.createElement(Tab, {onActive: this.props.onActiveFirstTab, 
               label: t('dashboard_modal_tab_fermenting')
          }, 
            React.createElement("div", {className: "modal-order-task-container"}, 
              React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                fermentingTask
              )
            )
          ), 
          React.createElement(Tab, {
            onActive: this.props.onActiveFirstTab, 
            label: t('dashboard_modal_tab_packaging')
          }, 
            React.createElement("div", {className: "modal-order-task-container"}, 
              React.createElement("ul", {className: "modal-order-task-list container-fluid"}, 
                packagingTask
              )
            )
          )
        )
      );
    }
  }
});

module.exports = ModalDashboardBrewNew;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModalBrew/DashboardModalBrewNew.jsx
 **/